import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const HeaderWrapper = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#004c83"};
  display: flex;
  justify-content: space-between;
  padding: 5px 30px;
  border-radius: 5px 5px 0px 0px;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  font-weight: normal;
`;

export const SolutionContainer = styled.div`
  margin-left: 10px;
  display: ${(props) => (props?.display ? props.display : "none")};
`;

export const GrayDarkerSpan = styled.span`
  color: #474747;
`;

export const GraySpan = styled.span`
  color: #767676;
`;

export const PriceContainer = styled.span`
  margin-right: 10px;
`;

export const SolutionAllocation = styled.span`
  font-family: Lato;
  font-size: 22px;
  font-weight: 700;
  line-height: 49px;
  letter-spacing: 0px;
  text-align: center;
  color: #0a4986;
  background: #ffffff;
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: 100%;
  margin-top: 0px !important;
  margin-bottom: 5px !important;
`;

export const SolutionName = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #084987 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;

export const GroupComments = styled.div`
  background-color: #fff !important;
  padding: 5px;
`;

export const CommentsTextTitle = styled.h2`
  font-size: 16px;
  font-family: Lato;
  font-weight: 700;
  margin: 0px;
  text-align: left;
  color: #084987;
  text-transform: initial;
  line-height: 18px;
`;

export const CommentText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  margin: 0 0 5px 0px;
  text-align: left;
  color: #767676;
`;
